import React from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../../store/views/entityView";
import { usePermission } from "../../../../hooks/usePermission";
import { studyGroupToolsFilters, usefulToolsDashboardFilters } from "../../../../utils/entitiesFiltersUtils";
import Widget from "../../../features/widget/Widget";
import UsefulTool from "../../../features/usefulTool/UsefulTool";
import iconsList from "../../../ui/icons/iconsList";
import classes from "./UseFullToolByDomain.module.css";

const MAX_TOOLS_TO_SHOW = 6;

const UseFullToolByDomain = ({ studyGroupIds = [] }) => {

    const hasPermission = usePermission();
    const { texts, lang } = useSelector(state => state.translate);
    const defaultTools = useSelector((state) => selectEntitiesByFilters(state, usefulToolsDashboardFilters)).filter(tool => hasPermission(tool.visibleTo))?.slice(0, MAX_TOOLS_TO_SHOW);
    const studyGroupTools = useSelector((state) => selectEntitiesByFilters(state, studyGroupToolsFilters(studyGroupIds), [studyGroupIds]));
    const tools = studyGroupTools?.length > 0 ? studyGroupTools : defaultTools;

    return (
        <Widget
            color="#4A4A4A"
            title={texts.usefulToolsDomainTitel}
            titleColor="white"
            icon={iconsList.usefulTools}
            className={classes.UsefulToolsWidget}
        >
            <div className={classes.ToolsList}>
                {tools?.length > 0 ?
                    tools.map((tool, index) =>
                        <div key={tool.toolId || tool.id || index} className={classes.ToolItem}>
                            <UsefulTool tool={{ ...tool, name: tool.name?.[lang] ?? tool.name }} />
                        </div>
                    )
                    :
                    <div className={classes.NoTools}>
                        {texts.noUsefulTools}
                    </div>
                }
            </div>
        </Widget>
    );
};

export default UseFullToolByDomain;
